module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Snoozed-mail-12389284e1fe72ee613933f1e433dc45.svg";